export default __webpack_public_path__ + "media/download2x.0053ed98.png";